import BaseModel from "@/core/components/input-widget/BaseModel";

export default class ExtraParameters extends BaseModel {

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}